import { defineComponent as _defineComponent } from 'vue'
import { ITask, ITaskStatus } from "@/api/types/tasks";
import { computed, ref } from "vue";
import SvgArrowDown from "@/assets/icons/arrow-down.svg";
import SvgArrowRight from "@/assets/icons/arrow-right.svg";
import { changeTaskStatus } from "@/api/tasks";
import store from "@/store";
import { showServerError } from "@/utils";
import BaseCircleLoader from "@/components-UI/BaseCircleLoader.vue";
import { useTasksStore } from "@/store_v3/MyTasksStore";
import { useTeleportToBody } from "@/utils/teleportToBody";

interface Props {
    task: ITask;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'TaskStatus',
  props: {
    task: null
  },
  setup(__props: any) {

const props = __props as {
    task: ITask;
}



const updatedStatus = ref('');
const getCurrentStatus = computed(() => updatedStatus.value || props.task.status);


const getStatusParams = computed(() => {
    const statusMap = {
        to_do: {
            text: "К выполнению",
            class: "to_do",
            actionText: 'Завершено',
            actionStatus: 'done',
        },
        done: {
            text: "Завершено",
            class: "done",
            actionText: 'В работу',
            actionStatus: 'to_do',
        },
        expired: {
            text: "Просрочено",
            class: "expired",
            actionText: "Завершено",
            actionStatus: 'done',
        },
        deleted: {
            text: "Удалена",
            class: "deleted",
        },
    };
    return statusMap[getCurrentStatus.value] ?? { text: '', class: '', actionText: '' };
});

const isDisableEdit = computed(() => {
    if (props.task.status === 'deleted') return true;
    const user = store.getters['authModule/GET_USER'];
    return user.account_id !== props.task.assignee?.id!;
});

const isShowAction = ref(false);
const isShowDropdown = computed(() => isShowAction.value && !isLoading.value);

const activatorEl = ref<HTMLElement | null>(null);
const dropdownEl = ref<HTMLElement | null>(null);
const { teleportToBody } = useTeleportToBody();

const showAction = () => {
    if (isShowAction.value) return;
    teleportToBody(dropdownEl.value, activatorEl.value, 'bottom');
    isShowAction.value = true;
};
const hideAction = () => {
    isShowAction.value = false;
};

const isLoading = ref(false);
const { setUpdateTaskFlag } = useTasksStore();

const changeStatus = async (status: ITaskStatus) => {
    try {
        isLoading.value = true;
        await changeTaskStatus(props.task.id, status);
        updatedStatus.value = status;
        hideAction();
        setUpdateTaskFlag(true);
    } catch (err) {
        showServerError(err, 'Статус не изменен');
    } finally {
        isLoading.value = false;
    }
};


return { __sfc: true,props, updatedStatus, getCurrentStatus, getStatusParams, isDisableEdit, isShowAction, isShowDropdown, activatorEl, dropdownEl, teleportToBody, showAction, hideAction, isLoading, setUpdateTaskFlag, changeStatus, SvgArrowDown, SvgArrowRight, BaseCircleLoader }
}

})